 <template>
  <div class="login" style="direction: rtl">

      <div class="p-grid p-jc-center ">
      <system-messages-display class="p-pt-3 system-messages-display"/>

    </div>
      <div class="p-grid p-jc-center p-pt-3">
        <PresenceShow class="presence-show "></PresenceShow>
    </div>
<!--    <SpeedDial :model="items" direction="up" className="speeddial-right" buttonClassName="p-button-danger" />-->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PresenceShow from "./Home/PresenceShow";
import SystemMessagesDisplay from "./Home/SystemMessages";

export default {
  name: "home",
  components: {PresenceShow, SystemMessagesDisplay},
  mounted() {
  },
  methods: {
  },
  created() {},
  data() {
    return {

    };
  },
  computed: {
    ...mapState(["intro", "user"]),
  },
};
</script>

<style >
@media screen and (max-width: 2200px) {
    .system-messages-display{
        max-width: 60vw !important;
    }
}
@media screen and (max-width: 1200px) {
  .presence-show {
    width: 70rem !important;
  }
    .system-messages-display{
    max-width: 70vw !important;
  }
}
@media screen and (max-width: 992px) {
  .presence-show {
    width: 95vw !important;
  } .system-messages-display {
          max-width: 95vw !important;
  }
}
@media screen and (max-width: 768px) {
  .presence-show {
    width: 97vw !important;
  }.system-messages-display {
         max-width: 97vw !important;
  }
}
@media screen and (max-width: 576px) {
  .presence-show {
    width: 100vw !important;
  }
    .system-messages-display {
        max-width: 100vw !important;
  }

}
</style>
